import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Alert } from '@mui/material';

export default function ConfirmDialog({
  open,
  patientName,
  onConfirm,
  onClose
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm reconciliation</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Patient: <strong>{patientName || '-'}</strong>
        </Typography>
        <Typography variant="body2">The reconciled plan will be submitted (mock).</Typography>
        <Alert severity="info" sx={{ mt: 2 }}>
          Are you sure you want to confirm the reconciliation?
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm}>Confirm</Button>
      </DialogActions>
    </Dialog>
  );
}
